(()=>{
  if(window.__pwPreorderPanelReady)return;
  window.__pwPreorderPanelReady=true;
  const selector='[data-pw-preorder-panel]';
  const lock=()=>{
    document.querySelectorAll(selector+':not(.pw-preorder-unlocked)').forEach(panel=>{
      const content=panel.querySelector('.pw-preorder-panel__content');
      if(content)content.inert=true;
    });
  };
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',lock,{once:true});
  }else{
    lock();
  }
  document.addEventListener('shopify:section:load',lock);
  document.addEventListener('quickshop:opened',lock);
  document.addEventListener('click',event=>{
    const trigger=event.target.closest('[data-pw-preorder-unlock]');
    if(!trigger)return;
    const panel=trigger.closest(selector);
    if(!panel)return;
    event.preventDefault();
    panel.classList.add('pw-preorder-unlocked');
    const content=panel.querySelector('.pw-preorder-panel__content');
    if(content)content.inert=false;
    const overlay=panel.querySelector('[data-pw-preorder-overlay]');
    if(overlay)overlay.remove();
    const addToCart=panel.querySelector('block-buy-buttons .add-to-cart');
    if(addToCart&&!addToCart.disabled)addToCart.focus({preventScroll:true});
  });
  document.addEventListener('submit',event=>{
    if(event.target.closest(selector+':not(.pw-preorder-unlocked)')){
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },true);
})();